import { message } from "antd";
import axios from "axios";
import { APIS } from "../pages/admin/common";

message.config({
  top: 100
});

axios.interceptors.request.use(function (config) {
  config.headers["x-csrf-token"] =
    document.cookie.match(/csrfToken=([^;]+)/)?.[1] ?? "";
  return config;
});
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.log(error);
    // skip error message when url is /api/admin/login
    if (error.config.url === APIS.LOGIN) {
      return Promise.reject(error);
    }

    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      message.error("登录过期，请重新登录");
      window.location.href = "/admin/login";
      return;
    }

    message.error("网络请求错误，请稍后重试");

    return Promise.reject(error);
  }
);

export function get(url: string, params?: any) {
  return axios.get(url, { params }).then((res) => res.data);
}

export function post(url: string, data?: any) {
  return axios.post(url, data).then((res) => res.data);
}
